import { useRef } from 'react';
import { LineItemsGridRef, LineItemsGrid, LineItemsGridProps } from './LineItemsGrid';
import { Grid } from '@mui/material';

export const LineItemsRecordView = ({ isOpen, recordId, headers, recordTypeId, showCustomNoRowsOverlay }: LineItemsGridProps) => {
    const lineItemGridRef = useRef<LineItemsGridRef | null>(null);

    return (
        <Grid container sx={{ height: 'calc(100% - 52px)', pl: '24px' }}>
            <Grid item xs={12} container spacing={1} height="100%" sx={{ position: 'relative' }}>
                <LineItemsGrid
                    isOpen={isOpen}
                    recordId={recordId}
                    headers={headers}
                    recordTypeId={recordTypeId}
                    showCustomNoRowsOverlay={showCustomNoRowsOverlay}
                    ref={lineItemGridRef}
                />
            </Grid>
        </Grid>
    );
};
